import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { ChatMessage } from '../../../domain/messages/models/ChatMessage';
import ChatHistoryItem from './ChatHistoryItem';

const useStyles = makeStyles({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    content: {
        width: '85%',
        paddingTop: '10px',
    },
});

export interface ChatHistoryProps {
	messages: ChatMessage[];
}

const ChatHistory: React.FC<ChatHistoryProps> = ({ messages }) => {
	const styles = useStyles();

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				{messages.map((message, index) => (
                    <ChatHistoryItem
                        key={`${message.timestamp}-${message.id ?? message.userName}-${index}`}
                        message={message}
                        messageIndex={index}
                    />
                ))}
			</div>
		</div>
	);
};

export default ChatHistory;
